import { useState } from "react";
import { gameArray } from "../../utils/gameArrat";
import { Box, Button, Typography, Select, FormControl, MenuItem, InputLabel, FormHelperText, TextField, InputAdornment, OutlinedInput, Dialog, DialogTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchSell } from "../../store/slice/coinSlice";
import CircularProgress from '@mui/material/CircularProgress';

const steps = [1, 10, 100, 1000, 10000, 100000, 1000000];

function getNiceCoins(rate) {
    const pricePerCoin = 1 / (rate / 0.9);

    for (let step of steps) {
        if (step * pricePerCoin >= 1) {
            let stepOut = step;
            switch (step) {
                case 1000:
                    stepOut = '1K';
                    break;

                case 10000:
                    stepOut = '10K';
                    break;

                case 100000:
                    stepOut = '100K';
                    break;
                case 1000000:
                    stepOut = '1M';
                    break;
            }

            return {
                coins: stepOut,
                usd: (step * pricePerCoin).toFixed(2)
            };
        }
    }

    return null;
}



const formatter = new Intl.NumberFormat('ru-RU');
const AccountSell = () => {

    const dispatch = useDispatch()
    const { isLoading } = useSelector(state => state.coin)

    const [game, setGame] = useState(gameArray[0]['name'])
    const [name, setName] = useState('')
    const [coin, setCoin] = useState('')
    const [amount, setAmount] = useState(null)
    const [server, setServer] = useState(gameArray[0]['server'][0]['name'])
    const [serverArray, setServerArray] = useState(gameArray[0]['server'])
    const [exchane, setExchange] = useState(getNiceCoins(gameArray[0]['server'][0]['rate']))
    const [amountNumber, setAmountNumber] = useState(null); // внутреннее число
    const [open, setOpen] = useState(false)

    const handleCoinChange = (e) => {
        const value = e.target.value.replace(/\s+/g, '');
        const exc = gameArray.find(item => item.name === game)
        const rate = exc.server.find(item => item.name === server)
        if (Number(value)) {
            const calculated = value / (rate.rate / 0.9)
            setAmount(formatter.format(calculated)) // для отображения
            setAmountNumber(calculated) // для логики кнопки
            setCoin(formatter.format(value))
        } else {
            setAmount(null)
            setAmountNumber(null)
            setCoin('')
        }
    }

    const hadleChangeGame = (game) => {
        setGame(game)
        setAmount('')
        setCoin('')
        setName('')
        const data = gameArray.find(item => item.name === game)
        setServerArray(data.server)
        setServer(data.server[0]['name'])
        setExchange(getNiceCoins(data.server[0]['rate']))
    }

    const handleChangeServer = (e) => {
        setServer(e.target.value)
        setAmount(null)
        setCoin('')
        setName('')

        const exc = gameArray.find(item => item.name === game)
        const rate = exc.server.find(item => item.name === server)
        setExchange(getNiceCoins(rate.rate))

    }



    const handleSubmit = async () => {

        const result = await dispatch(fetchSell({
            game: game,
            server: server,
            coins: coin,
            amount: amountNumber
        }))

        if (fetchSell.fulfilled.match(result)) {
            setAmount(null)
            setCoin('')
            setOpen(true)
            setAmountNumber(null)
        }
    }

    return (
        <>

            <Dialog
                open={open}
            >
                <DialogTitle sx={{textAlign:'center'}}>Монеты выставлены на продажу</DialogTitle>
                <Box
                    mb={2}
                    display='flex'
                    justifyContent='center'
                >
                    <Button 
                    variant="contained"
                    onClick={ () => setOpen(false) }
                    >ОК</Button>
                </Box>
            </Dialog>

            <Box>
                <Typography variant="h6">Продать монеты</Typography>
                <Typography variant="caption">В этом разделе вы можете выставить на продажу ваши игровые монеты</Typography>
            </Box>

            <Box>
                <Box display="flex" gap={2} >

                    <FormControl fullWidth sx={{ maxWidth: 300 }}>
                        <InputLabel id="game-label">Игра</InputLabel>
                        <Select
                            labelId="game-label"
                            id="game-select"
                            value={game}
                            label="Игра"
                            onChange={(e) => {
                                hadleChangeGame(e.target.value)
                            }}
                        >
                            {gameArray.map(item =>
                                <MenuItem key={item.name} value={item.name}>{item.name.replace("Купить", "Продать")}</MenuItem>
                            )}


                        </Select>
                        <FormHelperText>
                            {
                                'Цена продажи ' + exchane.coins + ' ~ ' + exchane.usd + ' руб'
                            }
                        </FormHelperText>
                    </FormControl>

                    <FormControl fullWidth sx={{ maxWidth: 250 }}>
                        <InputLabel id="game-label">Сервер</InputLabel>
                        <Select
                            labelId="game-label"
                            id="game-select"
                            value={server}
                            label="Сервер"
                            onChange={(e) => {
                                handleChangeServer(e)
                            }}
                        >
                            <MenuItem disabled value="">
                                <em>Сервер</em>
                            </MenuItem>

                            {serverArray.map(item =>
                                <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>
                            )}

                        </Select>
                    </FormControl>

                    <FormControl fullWidth sx={{ maxWidth: 350 }}>
                        <TextField
                            id="outlined-adornment-in-amount"
                            label="Кол-во монет"
                            value={coin}
                            onChange={(e) => handleCoinChange(e)}
                        />
                        <FormHelperText>
                            {
                                (amount && (Number(amount?.replace(',', '.')) < 50)) && "Недостаточное кол-во монет для продажи, минимальная прибыль должна быть не менее 50 руб"
                            }
                        </FormHelperText>
                    </FormControl>

                </Box>
            </Box>
            {
                amount &&
                <>
                    <Box
                        display="flex"
                        justifyContent="end"
                    >
                        <Typography>Прибыль: ~{amount} руб</Typography>
                    </Box>
                </>
            }
            <Box
                display="flex"
                justifyContent="end"
            >
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!amountNumber || amountNumber < 50}
                >
                    {isLoading ? <CircularProgress size="30px" sx={{ color: "#fff" }} aria-label="Loading…" /> : 'Выставить на продажу'}
                </Button>
            </Box>
        </>
    )
}

export default AccountSell;